export enum FundingToDateCellBlock {
  Root = 'FundingToDateCell',
}
